import { configureStore } from "@reduxjs/toolkit";
import weatherReducer from "./WeatherSlice.js";

export const store = configureStore({
  reducer: {
    weather: weatherReducer,
  },
});
